(function($, undefined) {
	
	'use strict';
	var respDetector;
	var footerInfosToggleBtn;
	var footerPrivacyToggleBtn;

	var toggleInfos = function() {
		if (respDetector.css('visibility') === 'visible') {	
			var ctn = $(this).closest('.footer-toggle-outer-ctn');
			ctn.toggleClass('open');
			ctn.find('.footer-element-to-toggle').slideToggle();
		}
	};

	var togglePrivacyPolicy = function() {
		var t = $(this);
		var label = t.attr('name');
		var val = t.val();
		var langs = $('html').attr('data-all-langs');
		var element = $('.' + label);
		var classes = element.attr('data-class');
		var extraClasses = '';

		if (t.attr('type') === 'checkbox') {
			val = t.prop('checked').toString();
		}

		element.removeClass();
		element.addClass(classes).addClass(extraClasses);

		updateLabelLangs(label, val, langs, function() {
			if (t.hasClass('refresh')) {
				window.location.reload();
			}
		}, true);
	};

	var init = function () {
		respDetector = $('.resp-detector-xs');
		footerInfosToggleBtn = $('.footer-toggle-trigger-element');
		footerPrivacyToggleBtn = $('.footer-toggle-privacy-policy');

		footerInfosToggleBtn.click(toggleInfos);
		footerPrivacyToggleBtn.click(togglePrivacyPolicy);
	};
	
	$(init);
	
})(jQuery);
